import styled from 'styled-components'

export const Wrapper = styled.input<{ error: boolean }>`
  border: 1px solid var(--grey-25);
  padding: 14px 16px;
  border-radius: 4px;
  box-sizing: border-box;
  background: white;
  font-weight: var(--font-regular);
  color: var(--brand-secondary);
  font-size: 16px;
  font-family: inherit;

  &::placeholder {
    color: var(--grey-100);
    font-size: 16px;
  }

  &:disabled {
    border: 1px solid #e5e7eb;
    background: #eef0f2;
  }

  ${({ error }) =>
    error &&
    `
      border: 1px solid var(--ui-red);
  `}

  &:focus {
    outline: none;
    border: 1px solid var(--brand-secondary);
  }
`
